import { render } from "./SingleCustomerChats.vue?vue&type=template&id=1055e1fa&scoped=true"
import script from "./SingleCustomerChats.vue?vue&type=script&lang=js"
export * from "./SingleCustomerChats.vue?vue&type=script&lang=js"

import "./SingleCustomerChats.vue?vue&type=style&index=0&id=1055e1fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1055e1fa"]])

export default __exports__